import { Component, Input, OnInit } from '@angular/core';
import { EventRequete, Partie } from '../../../entities/requete/requete.model';
import { UserService } from '../../../shared/index';

@Component({
    selector: 'jhi-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: ['./timeline.component.scss']
})
export class TimelineComponent implements OnInit {

    @Input() parties: Partie[];

    @Input() mesures: EventRequete[];

    @Input() orderAsc = true;

    @Input() juridiction: string;

    couleurMap = new Map<number, string>();

    idLecteur: number;
    constructor(private userService: UserService) {

    }

    ngOnInit() {
        this.userService.getAccount().then((account) => {
           this.idLecteur = account.id;
           this.initCouleurMap(this.idLecteur);
        });

    }


    initCouleurMap(idLecteur: number) {
        this.parties.forEach(partie => {
            if (partie.userId === idLecteur) {
                this.couleurMap.set(Number(partie.userId) , 'lecteur');
            } else {
                this.couleurMap.set(Number(partie.userId) , 'autre-partie');
            }
        });
    }

    getCouleurMap() {
        return this.couleurMap;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/requete/historique-requete/timeline/timeline.component.ts